import type { ErrorMap } from '@/app/error-registry';

export const MARK_READ_ERROR_MAP: ErrorMap = {
  PATCH: {
    notFound: 'notifications:apiErrors.markRead.notFound',
    forbidden: 'notifications:apiErrors.markRead.default',
    default: 'notifications:apiErrors.markRead.default',
  },
};

export const MARK_ALL_READ_ERROR_MAP: ErrorMap = {
  PATCH: {
    forbidden: 'notifications:apiErrors.markAllRead.default',
    default: 'notifications:apiErrors.markAllRead.default',
  },
};
